import ThisModule from "./ProtectedRoute";

export default ThisModule;
